import type { AdditionalSelectors } from '@makemydeal/dr-activities-fuel-saving';
import type { StateTree } from '@makemydeal/dr-dash-types';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import * as tradeInSelectors from '@makemydeal/dr-dash-store/selectors/trade';

/**
 * Additional selectors for fuel-saving activity.
 * These selectors extract vehicle and MPG data from the Dash application state
 * for use in fuel-saving calculations.
 */
export const additionalSelectors: AdditionalSelectors = {
    /**
     * Get the name of the selling vehicle (new vehicle) by VIN.
     * Extracts from Dash's vehicle state.
     */
    getSellingVehicleName: (state: StateTree) => {
        const year = vehicleSelectors.getVehicleYear(state);
        const make = vehicleSelectors.getVehicleMake(state);
        const model = vehicleSelectors.getVehicleModel(state);
        return `${year || ''} ${make || ''} ${model || ''}`.trim();
    },

    /**
     * Get the name of the trade-in vehicle.
     * Extracts from Dash's trade-in vehicle state.
     */
    getTradeVehicleName: (state: StateTree) => {
        const tradeInfo = tradeInSelectors.getTradeVehicleInfo(state);
        if (tradeInfo) {
            return `${tradeInfo.year || ''} ${tradeInfo.make || ''} ${tradeInfo.model || ''}`.trim();
        }
        return '';
    },

    /**
     * Get the MPG for the new vehicle.
     */
    getNewVehicleMpg: (_state: StateTree) => {
        // For now, return a placeholder since MPG data may come from external sources
        return undefined;
    },

    /**
     * Get the MPG for the trade-in vehicle.
     */
    getTradeVehicleMpg: (_state: StateTree) => {
        // For now, return a placeholder since MPG data may come from external sources
        return undefined;
    }
};
